import {Component} from "react"
import {isEmpty} from "lodash"

export default class ComponentWithData extends Component {
  constructor(props) {
    super(props)
    this.state = {
      resource_loader_state: "loading"
    }
  }

  reloadData() {
    this.setState({
      resource_loader_state: "loading"
    })
    this.getData()
      .then(data =>
        this.setState({
          resource_loader_state: "successful",
          data: data
        })
      )
      .catch(error =>
        this.setState({
          resource_loader_state: "failed",
          error: error.status ? error : "network error"
        })
      )
  }

  componentDidMount() {
    this.reloadData()
  }

  render() {
    if (this.state.resource_loader_state === "successful") {
      if (isEmpty(this.state.data) && typeof renderEmpty == "function") {
        return this.renderEmpty()
      } else {
        return this.renderWithData()
      }
    } else if (this.state.resource_loader_state === "failed") {
      return this.renderError()
    } else {
      // assumed to be 'loading'
      return this.renderLoading()
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/ComponentWithData.js